// hooks/useAdsManager.js
import { useEffect, useRef, useCallback } from "react";
import { GET_POST_ADS } from "../../constant/Apipath";
import { useSelector } from "react-redux";
import { Getrequestcall } from "../../request/Getrequest";

// Removed 'applovin' from ad rotation since AppLovin MAX has been removed
const adOrder = ["marketing", "cd"];

export const useAdsManager = () => {
  const cdAdsRef = useRef([]);
  const marketingAdsRef = useRef([]);

  const { loginData, multiLanguageData } = useSelector((state) => state.main);
  // --- Fetch ads once ---
  const fetchAds = async () => {
    try {
      const res = await Getrequestcall(GET_POST_ADS, loginData?.accessToken);
      if (res?.data?.data && res?.data?.status === true) {
        cdAdsRef.current = res?.data?.data?.cdAds || [];
        marketingAdsRef.current = res?.data?.data?.marketingAds || [];
      }
    } catch (error) {
      console.error("Error :: [ useAdsManager => fetchAds ]", error);
    }
  };

  useEffect(() => {
    fetchAds();
  }, []);

  // --- Common merge logic (every 8 posts insert 1 ad) ---
  const mergeAdsIntoFeed = useCallback((feedData, interval = 5) => {
    const ads1 = cdAdsRef.current || []; // cd ads
    const ads2 = marketingAdsRef.current || []; // marketing ads

    // If no ads available, return feed as is
    if (!ads1.length || !ads2.length) {
      return [...feedData];
    }

    const finalList = [];
    let cdIndex = 0;
    let marketingIndex = 0;
    let adSequenceIndex = 0; // for rotation via adOrder

    for (let i = 0; i < feedData.length; i++) {
      finalList.push(feedData[i]);

      const shouldInsert = (i + 1) % interval === 0;

      if (shouldInsert) {
        const adType = adOrder[adSequenceIndex % adOrder.length];
        let ad = null;

        if (adType === "cd") {
          ad = {
            ...ads1[cdIndex % ads1.length],
            formatTypeId: "cd-ad",
            adIndex: `cd-${cdIndex}`
          };
          cdIndex++;
        } else if (adType === "marketing") {
          ad = {
            ...ads2[marketingIndex % ads2.length],
            formatTypeId: "marketing-ad",
            adIndex: `marketing-${marketingIndex}`
          };
          marketingIndex++;
        }

        if (ad) finalList.push(ad);
        adSequenceIndex++;
      }
    }

    return finalList;
  }, []);

  return {
    cdAdsRef,
    marketingAdsRef,
    mergeAdsIntoFeed
  };
};
